<template>
  <div class="grid grid-cols-[minmax(30px,150px)_1fr] gap-4 items-center mt-8">
    <FormLabel label="Metallic Plate for Base">
      <FormKit name="metallicPlate" type="checkbox" />
    </FormLabel>
    <FormLabel label="Text">
      <FormKit name="metallicPlateText" type="text" />
    </FormLabel>
    <FormLabel label="Price">
      <FormKit name="metallicPlatePrice" type="text" />
    </FormLabel>
    <DiscountField
      :values="values"
      checkboxName="metallicPlateDiscount"
      priceName="metallicPlateDiscountPrice"
      priceTypeName="metallicPlateDiscountType"
    />
  </div>
</template>
<script setup>
import DiscountField from "@/components/Order/DiscountField/DiscountField.vue";
import FormLabel from "../../../UI/Form/FormLabel.vue";

defineProps({
  values: {
    type: Object,
    default: () => ({}),
  },
});
</script>
